import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createPart, getParts, removePart } from "../../../../modules/ConfigurationModule/services/PartsConfigurationService";
import { localStorageGet, localStorageGetContent, localStorageGetSections, localStorageRemove, localStorageSave } from "../../../../services/localStorageService";
import { environment } from "../../../../environments/environment";

export const dropdownColumnMap = {
  1: "id",
  2: "categoryId",
  3: "subCategoryId",
  11: "ATAChapterNumber",
  12: "ATASectionNumber",
  13: "ATAParagraphNumber"
}
export const dropdownValueMap = {
  1: "id",
  2: "id",
  3: "id",
  11: "chapter_number",
  12: "section_number",
  13: "paragraph_number"
}
const draftStructure = {
  configuration: {
    parts: {
      row:true,
      general: true,
      engeneering: {
        interchangeability: true
      }
    }
  }
}

const draftStructure2 = {
  name: "row",
  children: [
    {name: "general"},
    {name: "engineering", children: [
      {name: "nla"}, {name: "timecontrols"}
    ]}
  ]
}

const draftStructure3 = [
  {name: "engineering", parent: "row"},
  {name: "general", parent: "row"},
  {name: "nla", parent: "engineering"},
  {name: "timecontrols", parent: "engineering"},
  {name: "kits", parent: "engineering"}
]

const draftHierarchy = {
  engineering: "row",
  general: "row",
  nla: "engineering",
  timecontrols: "engineering",
  kits: "engineering"
}

export const partsConfigurationSlice = createSlice({
  name: "partsConfiguration",
  initialState: {
    parts: [],
    newParts: {},
    idxParts: {},
    filters: { dropdowns: {}, txt: {} },
    search: "",
    orderBy: "",
    page: 0,
    totalPages: 1,
    loadingParts: false,
    drafts: {},
    editing:{}
  },
  reducers: {
    nextPage: (state, action) => {
      return { ...state, page: Math.min(state.page + 1, state.totalPages) };
    },
    setOrder: (state, action) => {
      return {...state, orderBy: action.payload, page:0};
    },
    setSearch: (state, action) => {
      console.warn("new search", action.payload);
      return {...state, search: action.payload};
    },
    updateFilters: (state, action) => {
      let { filters, usePrevious } = action.payload;
      if (usePrevious) filters = { dropdowns: { ...state.filters.dropdowns, ...filters.dropdowns }, txt: { ...state.filters.txt, ...filters.txt } };
      return { ...state, filters, page: 0 };
    },
    editRow: (state, action) => {
      let { partialValue, partId} = action.payload;
      // localStorageSave("configuration/parts/row", { partId }, { ...state.idxParts[partId], ...partialValue });
      return {
        ...state,
        idxParts: { ...state.idxParts, [partId]: { ...state.idxParts[partId], ...partialValue } }
      };
      // !
    },
    startEditing: (state, action) => {
      let {section, partId} = action.payload; 
      return {...state, editing: {...state.editing, [partId]: [...(state.editing?.[partId] ?? []), section, ...getAncestors(draftHierarchy, section)]}}
    } ,
    closeEditing: (state, action) =>{
      let {section, partId} = action.payload;
      return {...state, editing: {...state.editing, [partId]: removeTargetAndAncestors(draftHierarchy, state.editing?.[partId] ?? [], section)}}
    },
    setUnsave: (state, action) => {
      let {section, partId} = action.payload; 
      return {...state, drafts: {...state.drafts, [partId]: [...(state.drafts?.[partId] ?? []), section, ...getAncestors(draftHierarchy, section)]}}
    } ,
    closeUnsaved: (state, action) =>{
      let {section, partId} = action.payload;
      return {...state, drafts: {...state.drafts, [partId]: removeTargetAndAncestors(draftHierarchy, state.drafts?.[partId] ?? [], section)}}
    },
    closeDraft: (state, action) => {

      // let { partId, section, additionalSections, preventDiscard } = action.payload;
      // let currentSections = { ...(state.drafts[partId] ?? {}) };
      // [section, ...(additionalSections ?? [])].forEach(sectionItem => delete currentSections[sectionItem]);
      // let draftsCopy = { ...state.drafts };
      // let updatedSections = validateDraftSections(currentSections);
      // Object.keys((state.drafts[partId] ?? {})).forEach(draftSection => {
      //   if (!(draftSection in updatedSections)){
      //     localStorageRemove(`configuration/parts/${draftSection}`, {partId});
      //   } 
      // })
      // if (partId in state.newParts) localStorageRemove(`configuration/parts`, {partId});
      // (Object.keys(updatedSections).length > 0) ? draftsCopy[partId] = updatedSections : delete draftsCopy[partId];
      // if (!preventDiscard) {
      //   let parts = (partId in state.newParts) ? state.parts.filter(p => p.id !== partId) : state.parts;
      //   return { ...state, parts, drafts: draftsCopy, idxParts: {...state.idxParts, [partId]: state.partsBackup[partId]} }
      // }
      // // finishcallback?.(partId in state.newParts);
      // return { ...state, drafts: draftsCopy, idxParts: {...state.idxParts, [partId]: state.partsBackup[partId]} }
      return {...state};
    },
    discardPart: (state, action) => {
      let part  = action.payload;
      return {...state, parts: state.parts.filter(p => !(p.id === part?.id))}
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchParts.pending, (state, action) => {
      return { ...state, loadingParts: true }
    });
    builder.addCase(fetchParts.fulfilled, (state, action) => {
      if (action.payload){
      // let { page } = state;
      let { load, totalPages, filters, page } = action.payload;

      //TODO: take into account local storage drafts;

      // New parts are the parts that are in localstorage with version 0;
      
      
      // let drafts = localStorageGetSections("configuration/parts/", {}, "partId");
      // let rowDrafts = localStorageGetContent("configuration/parts/row", {}, "partId");
      // let newPartIds = localStorageGet("configuration/parts/new", {});
      // let newParts = applyFilters((page > 0 ? newPartIds.filter(id => !(id in state.newParts)) : newPartIds).map(id => rowDrafts[id]), filters);
      // let newPartsObj = {};
      // newPartIds.forEach(id => newPartsObj[id] = true);
      let backup = {};
      load.forEach(part => { backup[part.id] = part });
      return {
        ...state,
        loadingParts: false,
        parts: page > 0 ? [...state.parts, ...load] : [...load],
        totalPages: Math.max(totalPages, 1),
        idxParts: page > 0 ? { ...backup, ...state.idxParts } : { ...backup},
        newParts:{},
        page
      }} else {
        return {...state};
      }
    })
    builder.addCase(fetchParts.rejected, (state, action) => {
      return { ...state, loadingParts: false };
    });
    builder.addCase(newPart.fulfilled, (state, action) => {
      let { part } = action.payload;

      //TODO: new part shoud created unsaved
      // localStorageSave("configuration/parts/row", {partId: part.id}, part);
      // localStorageSave("configuration/parts/new", {partId: part.id}, part.id)
      return {
        ...state,
        parts: [part, ...state.parts],
        idxParts: { ...state.idxParts, [part.id]: part },
        drafts: { ...state.drafts, [part.id]: ["general", ...getAncestors(draftHierarchy, "general")] },
        editing: { ...state.editing, [part.id]: ["general", ...getAncestors(draftHierarchy, "general")] },
        newParts: {...state.newParts, [part.id]: true}
      }
    });
    builder.addCase(removePartAction.fulfilled, (state, action) => {
      let { partId }= action.payload;
      return {...state, parts:state.parts.filter(p => p.id !== partId)};
    })
  }
});

export const fetchParts = createAsyncThunk("partsConfiguration/fetchParts",
  async ({ page, searchValue }, { rejectWithValue, getState }) => {

    let { filters, orderBy, search, totalPages  } = getState().partsConfiguration;
    if (page < totalPages){
      // let response = await getParts(filters, dropdownColumnMap, page, environment.ElemensPerPage, orderBy, search);
      let response = await getParts(filters, dropdownColumnMap, dropdownValueMap, page, 20, orderBy, searchValue);
    if (response.data.responseCode === 200) {
      return {...response.data, filters};
    } else {
      rejectWithValue(null);
    }} else {
      rejectWithValue(null);
    }
  }
);

export const newPart = createAsyncThunk("partsConfiguration/newPart",
  async (p, { rejectWithValue, getState }) => {
    let response = await createPart({ id: null });
    if (response.data.responseCode === 201) {
      return { part: response.data.load };
    } else {
      rejectWithValue(null);
    }
  }
)

export const removePartAction = createAsyncThunk("partsConfiguration/removePartAction",
  async(partId, {rejectWithValue, getState}) => {
    let response = await removePart(partId);
    if (response.data.responseCode === 204) {
      return {partId};
    } else {
      rejectWithValue(false);
    }
  }
)

function validateDraftSections(sections) {  
  return validateAndPrune(draftStructure, sections);
}

function validtxtFilter(part, filters){
  return (filters && Object.keys(filters).length>0) ? Object.keys(filters).some(name => (part[name] ?? "")?.includes(filters[name] ?? "")) : true ;
}

const txtSearchKeys = ["categoryName", "subCategoryName", "partNumber", "description", "ata"];
const compoundProperties = (part) =>( {...part, ata: `${part.ATAChapterNumber ?? "00"}-${part.ATASectionNumber ?? "00"}-${part.ATAParagraphNumber?? "00"}`})

function validDropdownFilter(part, filters){
  return (filters && Object.keys(filters).length>0) ? (
    Object.entries(filters).every(([dropId, values]) => ((values.length > 0) ? values.some(value => part[dropdownColumnMap[dropId]] === value.id) : true))
  ) : true;
}

function applyFilters(parts, filters) {
  let {dropdowns, txt} = filters;
  let searchFilter = Boolean(txt?.description) ? {...txt, ...Object.fromEntries(txtSearchKeys.map(k => [k, txt.description])) }: txt;
  return parts.filter(p => p && validtxtFilter(compoundProperties(p), searchFilter) && validDropdownFilter(p, dropdowns));
}


function validateAndPrune(structure, obj) {
  const prune = (hierarchy, valueObj) => {

    let returnObj = {};
    Object.keys(hierarchy).forEach(key => {
      if (key in valueObj) {
        if (hierarchy[key] === true) {
          returnObj[key] = true;
        } else {
          let partialPrune = prune(hierarchy[key], valueObj);
          if (Object.keys(partialPrune).length > 0) {
            returnObj[key] = true;
            returnObj = { ...returnObj, ...partialPrune };
          }
        }
      }

    });
    return returnObj;
  };
  let pruned = prune(structure, obj);
  return pruned;
}


function getAncestors(map, target) {
  const ancestors = [];
  let current = map[target];

  while (current) {
    ancestors.push(current);
    current = map[current]; // Move up to the parent
  }

  return ancestors.reverse(); // Reverse for root-to-node order
}

function removeTargetAndAncestors(parentMap, activeList, target) {
  const updatedActiveList = new Set(activeList); // Use a Set for efficient operations

  let current = target;
  while (current) {
    // Get parent of the current node
    const parent = parentMap[current];

    // Remove current node from the active list
    updatedActiveList.delete(current);

    // Check if the parent has any remaining active children
    const hasActiveChildren = Object.keys(parentMap).some(
      (child) => parentMap[child] === parent && updatedActiveList.has(child)
    );

    if (!hasActiveChildren) {
      current = parent; // Move up to the parent
    } else {
      break; // Stop if the parent has other active children
    }
  }

  return Array.from(updatedActiveList); // Convert Set back to Array
}




export const { nextPage, closeDraft, discardPart, editRow, updateFilters, setOrder, setUnsave, closeUnsaved, setSearch, startEditing, closeEditing} = partsConfigurationSlice.actions;
export const selectPartsConfig = (state) => state.partsConfiguration;
export const selectPartsEditing = (state) => state.partsConfiguration.editing;
export const selectParts = (state) => state.partsConfiguration.parts;
export const selectOrder = (state) => state.partsConfiguration.orderBy;
export const selectSearch = (state) => state.partsConfiguration.search;
export const selectPartsFilters = (state) => state.partsConfiguration.filters;
export const selectPage = (state) => state.partsConfiguration.page;
export const selectIdxParts = (state) => state.partsConfiguration.idxParts;
export const selectPartDraftSections = (state) => state.partsConfiguration.drafts;
export const selectLoadingParts = (state) => state.partsConfiguration.loadingParts;
export const selectNewParts = (state) => state.partsConfiguration.newParts;

export default partsConfigurationSlice.reducer;